import React, { useState, useEffect } from 'react';
import DoaTable from './DoaTable';
import { getDoas, clearDoas } from '../../flux/actions/doaActions';
import { Container, Row, Col, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { DoaContainer, IDoaReduxProps } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUnlock, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';
import { PRIVILEGE } from '../../types/privileges'
import { useHistory } from 'react-router-dom';

const DoaContainerComponent = ({
  getDoas,
  clearDoas,
  doa,
  auth
 }: DoaContainer) => {
  const history = useHistory();
  const { doas, loading } = doa;
  const [tableData, setTableData] = useState(doas);
  const [showAllValue, setShowAllValue] = useState(false);
  
  const changeShowAllHandle = (e) => {
    setShowAllValue(e.target.checked);
  };

  useEffect(() => {
    getDoas();
  }, [getDoas]);

  useEffect(() => {
    return () => {
      clearDoas();
    }
  }, []);

  useEffect(() => {
    setTableData(showAllValue ? doas : doas.filter(e => e.approved === -1));
  }, [doas, showAllValue]);

  return loading ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="10"><h3 className="title" style={{marginBottom: 0}}><FontAwesomeIcon icon={faUnlock} />&nbsp;&nbsp;Demandes d'ouverture en association</h3></Col>
          <Col xs="12" md="2" style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
            <CustomInput type="switch" id="showAll" name="showAllSwitch" label="Afficher tout" checked={showAllValue} onChange={changeShowAllHandle} />
            &nbsp;<FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="showAll_tooltip" />
            <ReactTooltip effect="solid" id="showAll_tooltip" type={"dark"}>
              Inclure les demandes déjà répondues
            </ReactTooltip>
          </Col>
        </Row>
        {!!auth?.user?.privileges?.includes(PRIVILEGE.APPROVE_DIVISION) && <Row className="justify-content-end">
          <div style={{textDecoration: "underline", cursor: "pointer"}} onClick={() => history.push({ pathname: `/demandes_repartition` })}>N'afficher que les demandes de répartition</div>
        </Row>}
      </Container>
      <DoaTable doasData={tableData} />
    </>
  );
};

const mapStateToProps = (state: IDoaReduxProps) => ({
  doa: state.doa,
  auth: state.auth
});

export default connect(mapStateToProps, { getDoas, clearDoas })(DoaContainerComponent);
